import React from 'react';
import RootRouter from './route/RootRouter';
import GlobalModal from './components/common/GlobalModal';
import GlobalLoading from './components/common/GlobalLoading';
import './styles/common.css';

function App() {
    return (
        <>
            <RootRouter />
            <GlobalModal />      {/* 전역 모달 */}
            <GlobalLoading />    {/* 전역 로딩 */}
        </>
    );
}

export default App;